var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 3@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M779.01746,184.14629 L773.50026,189.66219 L767.98436,184.14629 C767.46696,183.64709 766.64406,183.66139 766.14616,184.17749 C765.65996,184.68189 765.65996,185.48009 766.14616,185.98449 L771.66206,191.50039 L766.14616,197.01499 C765.62876,197.51419 765.61446,198.33839 766.11366,198.85319 C766.61156,199.36929 767.43576,199.38489 767.95186,198.88569 C767.96226,198.87529 767.97266,198.86489 767.98436,198.85319 L773.50026,193.33859 L779.01616,198.85319 C779.51536,199.36929 780.33826,199.38489 780.85436,198.88569 C781.37046,198.38779 781.38476,197.56359 780.88556,197.04749 C780.87646,197.03709 780.86606,197.02669 780.85436,197.01499 L775.33846,191.50039 L780.85436,185.98449 C781.36266,185.47749 781.36266,184.65459 780.85566,184.14629 C780.34606,183.63799 779.52576,183.63799 779.01746,184.14629 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-51.6%",
    y: "-38.7%",
    width: "203.2%",
    height: "203.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Waithing-room-and-ongoing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-3",
    transform: "translate(-761.000000, -181.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    d: "M779.936073,183.265065 C780.395887,183.265065 780.856124,183.440547 781.209666,183.79319 C781.560672,184.145096 781.736073,184.605948 781.735747,185.066517 C781.735421,185.527129 781.559384,185.987472 781.207913,186.338043 L781.207913,186.338043 L776.045605,191.500352 L781.213826,196.66745 C781.573829,197.039805 781.746816,197.505887 781.746816,197.962448 C781.746816,198.43389 781.562589,198.897187 781.20198,199.245079 C780.844665,199.590694 780.381213,199.758252 779.9206,199.750109 C779.460064,199.741966 779.002355,199.558094 778.662648,199.206785 L778.662648,199.206785 L773.500257,194.045611 L768.33234,199.21223 C767.960022,199.573079 767.494036,199.746137 767.03752,199.746137 C766.565894,199.746137 766.102309,199.56157 765.75471,199.201263 C765.408765,198.844507 765.24061,198.380568 765.248765,197.919268 C765.25691,197.458615 765.4409,197.00066 765.792648,196.661395 L765.792648,196.661395 L770.954915,191.500345 L765.786172,186.331489 C765.449706,185.982429 765.28151,185.5317 765.28151,185.08099 C765.28151,184.63028 765.449706,184.179551 765.786319,183.830338 C766.131241,183.472808 766.588734,183.289044 767.049626,183.281222 C767.509887,183.27341 767.973553,183.441081 768.337913,183.792737 L768.337913,183.792737 L773.500302,188.955125 L778.663907,183.792737 C779.015873,183.44077 779.475932,183.265065 779.936073,183.265065 Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/crossIcon.7710774ae802f0f13f77bc0941d2496a.svg";
export { ForwardRef as ReactComponent };